import React from 'react'

export const LoginTemplate: React.FC = ({children}) => {
  return (
    <div className="flex fixed top-[25%] left-[50%] ml-[-186px] items-center min-h-screen flex-col">
      {children}
    </div>
  )
}
